module.exports = function getResource(label, vars = []) {
    let resources = {
        default: 'Par défaut',
        sort: 'Trier',
        sortBy: 'Trier par'
    };

    return resources[label];
};
